export default {
  title: "Destek",
  payments: "Ödemelerle ilgili tüm sorular için lütfen {finance_email} adresine e-posta gönderin.",
  spam: 'Önemli: lütfen "Spam" klasörünü kontrol edin!',
  other: "Diğer tüm sorular için lütfen aşağıdaki formu kullanın.",
  faq: "sıkça sorulan sorular",
  faq_notice:
    "Bir talep göndermeden önce lütfen kurallarımızı ve {faq} (FAQ) bölümünü inceleyin — yanıtı zaten orada olabilir.",
  response_time:
    "Talebin karmaşıklığına ve destek ekibinin mevcut yoğunluğuna bağlı olarak yanıt 12 saatten 2 iş gününe kadar sürebilir."
};
